import settingImage from "../assets/svg/elm-header-photo.svg";

const Settings = () => {
	return (

		<div className="md:p-10 p-4 bg-white">
			<div className="flex space-x-2 md:space-x-10 flex-wrap ">
				<div className="relative rounded-full h-22 w-22 md:h-24 md:w-24 border-4 border-solid border-f4 p-px mb-6 md:mb-12">
					<img
						alt=""
						src={settingImage}
						className="rounded-full w-full h-full inline object-cover"
					/>
				</div>
				<div className="pt-3">
					<span className="md:text-xl text-base  font-bold">Jonathan Doe</span>
					<div className="bg-ef opacity-10"></div>
					<div className="flex">
						<div className="mt-2">
							<span className="text-ef p-1 px-2 text-xs md:text-sm bg-ef bg-opacity-10 text-center">
								Basic Plan
							</span>
						</div>
						<div className='ml-2 flex text-center items-center mt-2'>
							<span className="text-ef underline font-bold text-xs md:text-base">
								Upgrade
							</span>
						</div>
					</div>
				</div>
				<div className="pt-3">
					<button
						className=" grid place-items-center w-11 h-11 bg-f4 font-bold rounded-xl hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
						type="button"
					>
						<i className="text-2xl text-black iconly-Edit-Square icli"></i>
					</button>
				</div>
			</div>
			<hr className="bg-f4 -mx-10" />
			<div className="mt-6  md:flex ">
				<div className="">
					<label className="block text-gray-700 text-sm font-bold mb-2">
						Email
					</label>
					<div className="relative">
						<input
							className="shadow appearance-none border rounded w-full lg:w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
							type="text"
							placeholder="Email"
						/>
						<div className=" absolute top-2  right-4 text-gray-700">
							<span className="underline text-ef">Change</span>
						</div>
					</div>
				</div>
				<div className="md:ml-8 mt-4 md:mt-0">
					<label
						className="block text-gray-700 text-sm font-bold mb-2"
						for="password"
					>
						Password
					</label>
					<div className="relative">
						<input
							className="shadow appearance-none border  rounded w-full lg:w-96 py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
							id="password"
							type="password"
							placeholder="******************"
						/>
						<div className=" absolute top-2 right-4 text-gray-700">
							<span className="underline text-ef">Change</span>
						</div>
					</div>
				</div>
			</div>
			<div className="md:mt-6 mt-2">
				<span className="text-xl font-bold">Preferences</span>
				<p className="text-gray-400 text-sm lg:text-lg pt-3">
					Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cum
					repellat quod inventore enim alias pariatur mollitia perspiciatis
					quisquam praesentium repudiandae, quasi possimus ducimus dolorum
					corporis veritatis eum suscipit quas necessitatibus.
				</p>
				<div className="inline-block relative w-full md:w-96 pt-3 cursor-pointer">
					<select className="block appearance-none w-full bg-white border  px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
						<option>Consectetur adipiscing elit</option>
						<option>Option 2</option>
						<option>Option 3</option>
					</select>
					<div className=" absolute top-5 right-0  px-2 text-gray-700 font-extrabold">
						<i className="iconly-Arrow-Down-2 icli"></i>
					</div>
				</div>
			</div>
			<hr className="bg-f4 -mx-10 mt-8 lg:mt-14" />

			<div className="mt-6 mb-6 md:mb-10">
				<div className="my-auto">
					<span className="mdi mdi-delete text-xl text-ef"></span>{" "}
					<span className="text-ef text-lg pl-1">
						I want to delete my account
					</span>
				</div>
			</div>
		</div>
	);
};

export default Settings;
